import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Accordion, Badge, Button, CloseButton, Col, Container, FloatingLabel, Form, Image, Row, Tab, Tabs } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import { Link, useNavigate, useParams } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import * as ImageUtil from '../service/ImageUtil';
import { LoginInfo } from '../App';
import { isFollow, followDelete, followPost, getFollowList, getFollowerList } from '../service/FollowService';
import parse, { domToReact } from 'html-react-parser'
import { LinkContainer } from 'react-router-bootstrap';
import FollowButton from './FollowButton';
import RegistConfirm from './RegistConfirm';
import { useTranslation } from "react-i18next";
import Thumb from './common/Thumb';
import SettingPopup from './SettingPopup';
import RankingRecordPopup from './RankingRecordPopup';
import SeriesEditPopup from './SeriesEditPopup';
import UserManageInfo from './UserManageInfo';
import PointSend from './PointSend';
import UserMark from './UserMark';
import { arrayShuffle, imgPath } from '../service/CommonUtil';
import { Alert, Card, CardContent, CardHeader, CardMedia, Checkbox, Chip, Divider, FormControlLabel, FormGroup, Grid, ImageList, ImageListItem, Paper, Table, TextField } from '@mui/material';
import MuiButton from '@mui/material/Button'
import PlanConfirmDialog from './common/PlanConfirmDialog';
import Plan from './Plan';
import CommonDialog from './common/CommonDialog';
import CharacterEditPopup from './CharacterEditPopup';
import CopyToClipboardButton from './common/CopyToClipboardButton';
import CharacterViewPopup from './CharacterViewPopup';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import AITalk from './AITalk';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

const Character = (props) => {
    async function getImageInfo(groupId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/character/info/"+groupId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getUserInfo(userIdOrDisplayId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/"+userIdOrDisplayId)
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getImage(userId,order,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/user/"+userId+"/"+order+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getCharacterImageList(groupId,order,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/character/"+groupId+"/"+order+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getOsusumeImage(userId,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/userOsusume/"+userId+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getCommunityImageList(userId,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/community/user/"+userId+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function deleteCommunityImage(groupId){
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/community/user/"+groupId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getSeriesList(userId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/series/list/"+userId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function deleteSeries(seriesId){
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/series",{seriesId:seriesId}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function refererUser(displayIdOrUserId){
        return await new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/regist/referrer",{displayIdOrUserId:displayIdOrUserId}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function updateAgeLimitByAdmin(groupId,ageLimit){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/ageLimit/"+groupId,{ageLimit:ageLimit})
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function updateStyleOfPaintingByAdmin(groupId,style){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/style/"+groupId,{style:style})
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function sendMosaicNoticeByAdmin(groupId){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/mosaic/"+groupId)
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function updateStatusByAdmin(userId,status,reason){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/login/status/"+userId,{status:status,reason:reason})
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function aiGenerateSuspendByAdmin(userId){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/userSetting/aiGenerateSuspend/"+userId,{})
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getPlanList(userId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/plan/list/"+userId)
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function getSex(sex){
        if(sex === undefined){
            return ""
        } else if(sex === 1){
            return "男性"
        } else if(sex === 2){
            return "女性"
        } else if(sex === 3){
            return "その他"
        }
    }
    function clearAllInterval(){
        for (var i = 1; i < 99999; i++)
            window.clearInterval(i)
    }
    // アップロード処理
    function upload(files){
        let fapi = new ApiFetch()
        let fd = new FormData();
        fd.append("text",document.getElementById("text").value)
        for(let i = 0;i < files.length;i++){
            fd.append("file[]",files[i])
        }
        fapi.fileUpload(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/upload/community",fd).then((r)=>{
            r.json().then(json=>{
                if(json.result){
                    let text = document.getElementById("text")
                    let file = document.getElementById("file")
                    text.value = ""
                    file.value = ""

                    setCommunityImage("")
                    dialog("投稿完了","投稿が完了しました。")

                    getCommunityImageList(userId,1).then(r=>{
                        if(r.result){
                            if(r.data.length > 0){
                                setCommunityMessage("")
                            } else {
                                setCommunityMessage("投稿がありません。")
                            }
                            setCommunityImageList(r.data)
                        }
                    })
                } else {
                    setOkButtonShow(false)
                    dialog("エラー",json.errors.join("\r\n"))
                }
            })
        }).then(r=>{

        })
    }
    const {t} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲート
    const navigate = useNavigate();
    // 投稿遅延ロード
    const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05
      }
    const observer = new IntersectionObserver((entries,observer)=>{
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0){
                const imgEl = entry.target;
                //imgEl.src = imgEl.dataset.src;          
                observer.unobserve(entry.target)
                // ロードした部分まで進んだら追加読み込み
                if(imgEl.dataset.type === "community" && imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (communityPage * 10 - 1) ){
                    setCommunityPage(communityPage+1)
                    getCommunityImageList(userId,communityPage+1).then(r => {
                        if(r.result){
                            setCommunityImageList(communityImageList.concat(r.data))
                        }
                    })
                }
                if(imgEl.dataset.type === "follow" && imgEl.dataset.observe === "0" && imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (followPage * 6 - 1) ){
                    imgEl.dataset.observe = "1"
                    setFollowPage(followPage+1)
                    getFollowList(userId,followPage+1).then(r => {
                        if(r.result){
                            setFollowList(followList.concat(r.data))
                        }
                    })
                }
                if(imgEl.dataset.type === "follower" && imgEl.dataset.observe === "0" && imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (followerPage * 6 - 1) ){
                    imgEl.dataset.observe = "1"
                    setFollowerPage(followerPage+1)
                    getFollowerList(userId,followerPage+1).then(r => {
                        if(r.result){
                            setFollowerList(followerList.concat(r.data))
                        }
                    })
                }
              }
        })
    }, options);

    let param = useParams();
    let userIdOrDisplayId = param.id
    let tab = param.tab
    const [userId,setUserId] = useState("")
    const [link,setLink] = useState("")
    const [showEditPopup,setShowEditPopup] = useState(false)

    // 削除対象選択情報
    const [item, selectItem] = useState('');
    const [deleted, setDeleted] = useState('');

    // 検索情報
    const [page,setPage] = useState(0)
    const [communityPage,setCommunityPage] = useState(1)
    const [followPage,setFollowPage] = useState(1)
    const [followerPage,setFollowerPage] = useState(1)

    const [userInfo, setUserInfo] = useState([])
    const [characterInfo,setCharacterInfo] = useState([])
    const [characterDetail,setCharacterDetail] = useState([])
    const [showViewPopup,setShowViewPopup] = useState(false)
    const [osusumeImageList,setOsusumeImageList] = useState([...Array(0)])
    const [imageList,setImageList] = useState([...Array(0)])
    const [order,setOrder] = useState(param.order || "post_desc")
    const [unitSell,setUnitSell] = useState(false)
    const [membership,setMembership] = useState(false)
    const [message,setMessage] = useState('')
    const [communityMessage,setCommunityMessage] = useState('')
    const [follow,setFollow] = useState(false)

    // コミュニティ投稿用画像の一時保持
    const [communityImage,setCommunityImage] = useState("")
    // コミュニティ情報
    const [communityImageList,setCommunityImageList] = useState([])

    // フォロー
    const [followList, setFollowList] = useState([])
    const [followerList, setFollowerList] = useState([])
    const [followCount, setFollowCount] = useState(0)
    const [followerCount, setFollowerCount] = useState(0)
    const [subscriptionCount, setSubscriptionCount] = useState(0)

    // ポイント
    const [point,setPoint] = useState(0)
    const [totalPointsUsed,setTotalPointsUsed] = useState(0)
    const [postGetPoint,setPostGetPoint] = useState(0)
    const [basePoint,setBasePoint] = useState(0)
    const [numberOfUnitsUnderOperation,setNumberOfUnitsUnderOperation] = useState(0)

    // 投稿数
    const [imageCount,setImageCount] = useState(0)
    // 投稿枚数
    const [imageDetailCount,setImageDetailCount] = useState(0)
    // 合計閲覧数
    const [pvAllCount,setPVAllCount] = useState(0)
    // 過去3ヵ月間の平均PV
    const [pv3MonthCount,setPV3MonthCount] = useState(0)
    // 過去3ヵ月間の平均PV順位
    const [pv3MonthRank,setPV3MonthRank] = useState(0)
    // 過去3ヵ月間の平均いいね数
    const [favorite3MonthCount,setFavorite3MonthCount] = useState(0)
    // 合計いいねされた数
    const [favoriteCount,setFavoriteCount] = useState(0)
    // 合計いいねした数
    const [favoritedCount,setFavoritedCount] = useState(0)
    // 画像生成回数
    const [imageGenrationCount,setImageGenrationCount] = useState(0)
    // プラン状態
    const [planStatus,setPlanStatus] = useState([])

    // 設定
    const [showSetting,setShowSetting] = useState(false)
    // 実績
    const [showUserAchievements,setShowUserAchievements] = useState(false)
    // ランキング入賞履歴
    const [showRankingRecord,setShowRankingRecord] = useState(false)
    // プロンプト
    const [showPrompt,setShowPrompt] = useState(false)
        
    // プラン一覧
    const [planList,setPlanList] = useState([])

    // ダイアログ
    const [show, setShow] = useState(false)
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogMessage, setDialogMessage] = useState("")
    const [okButtonShow,setOkButtonShow] = useState(false)
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    // 初期処理
    useEffect(() =>{
        clearAllInterval()
        let currentPage = 1
        if(param.page === undefined){
            currentPage = 1
        } else {
            currentPage = parseInt(param.page)
        }
        setPage(currentPage)
        getImageInfo(userIdOrDisplayId).then(json => {
            if(json.result){
                setCharacterInfo(json.info)
                setCharacterDetail(json.detail)
            }
        })
        /*getUserInfo(userIdOrDisplayId).then(json => {
            if(json.result){
                // タイトル設定
                document.querySelector("title").textContent = json.user_name + " - ourt AI"
                setUserInfo(json)
                setFollowCount(json.follow)
                setFollowerCount(json.follower)
                setSubscriptionCount(json.subscription)
                setImageCount(json.image)
                setImageDetailCount(json.image_detail)
                setPVAllCount(json.pv)
                setPV3MonthCount(json.pv_3month)
                setPV3MonthRank(json.pv_3month_rank)
                setFavorite3MonthCount(json.favorite_3month)

                // 最大1枚25ポイント
                let avg = json.pv_3month
                let p = 0
                if(avg <= 500){
                    p = Math.floor(avg / 5) // 5閲覧数に対して1ポイント増加。最大50ポイント
                } else {
                    p = 50
                }
                setPostGetPoint(p*10)
                setBasePoint(json.base_point)
                setNumberOfUnitsUnderOperation(json.number_of_units_under_operation)
                setFavoriteCount(json.favorite)
                setFavoritedCount(json.favorited)
                setPoint(json.point.point)
                setTotalPointsUsed(json.point.total_points_used)
                setImageGenrationCount(json.image_generation_count)
                setPlanStatus(json.plan_status)

                let targetUserId = json.user_id
                setUserId(targetUserId)
                isFollow(targetUserId,() => {}).then(r => {
                    setFollow(r)
                })
        
                // シリーズ
                getSeriesList(targetUserId).then(r => {
                    if(r.result){
                        setSeriesList(r.data)
                    }
                })
                setFollowPage(1)
                setFollowerPage(1)
                getFollowList(targetUserId,1).then(r => {
                    if(r.result){
                        setFollowList(r.data.concat([]))
                    } else {
                        setFollowList([].concat([]))
                    }
                })
                getFollowerList(targetUserId,1).then(r => {
                    if(r.result){
                        setFollowerList(r.data.concat([]))
                    } else {
                        setFollowerList([].concat([]))
                    }
                })
                setLink("https://twitter.com/intent/tweet?ref_src=twsrc%5Etfw%7Ctwcamp%5Ebuttonembed%7Ctwterm%5Emention%7Ctwgr%5Eourt_official&text="
                + encodeURIComponent(json.user_name + "さんのマイページ\n" + ApiFetch.API_PROTOCOL+"//ourt-ai.work/user/"+(json.display_id.length > 0 ? json.display_id : json.user_id) + "\n#アワートAI #AIイラスト #AIart")
                )
            } else {
                dialog(t("common.error"),json.errors)
            }
        })*/
    },[userIdOrDisplayId])

    // ページ遷移
    useEffect(() =>{
        // 初期処理では取得せず、ページ番号が確定してから取得する
        if(page > 0 && userIdOrDisplayId !== ""){
            getImageList(userIdOrDisplayId,order,page)
        }
    },[userIdOrDisplayId,order,page])

    function getImageList(userId,order,page){
        getCharacterImageList(userId,order,page).then(json => {
            if(json.result){
                if(json.data.length > 0){
                    setMessage("")
                } else {
                    setMessage("投稿がありません。")
                }
                // スクロールを最上位に戻す
                //window.scrollTo({top:0,left:0,behavior:"instant"})
                setImageList(json.data)
            }
        })
    }

    // ログインユーザー自身のページを表示しているか？
    const [isMe,setIsMe] = useState(false)

    useEffect(() => {
        let entered = false
        if(loginInfo.result && userInfo.user_id !== undefined && loginInfo.userId !== userInfo.user_id){
            // 自分自身以外のページを表示しているとき
            setIsMe(false)
            setTabKey("osusume")
            getOsusumeImage(userInfo.user_id,page).then(json => {
                if(json.result){
                    // スクロールを最上位に戻す
                    window.scrollTo({top:0,left:0,behavior:"instant"})
                    setOsusumeImageList(arrayShuffle(json.data))
                }
            })
            entered = true
        } else if (loginInfo.result && loginInfo.userId === userInfo.user_id){
            // 自分のページを表示しているとき
            setIsMe(true)
            setTabKey("account")
            entered = true
        }
        if(tab !== undefined){
            handleTabSelect(tab)
            setTabKey(tab)
        } else {
            if(!entered){
                getPlanList(userInfo.user_id).then(r => {
                    if(r.result){
                        setPlanList(r.data)
                    } else {
                        setPlanList([].concat())
                    }
                })
                setTabKey("account")
            }
        }
    },[loginInfo,userInfo,tab])

    // 画像遅延ロード
    useEffect(() => {
        document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    },[imageList,communityImageList,followList,followerList])

    const [tabKey,setTabKey] = useState(false)

    function handleTabSelect(e){
        setTabKey(e)
        if(e === "community"){
            if(communityImageList.length === 0){
                getCommunityImageList(userId,1).then(r=>{
                    if(r.result){
                        if(r.data.length > 0){
                            setCommunityMessage("")
                        } else {
                            setCommunityMessage("投稿がありません。")
                        }
                        setCommunityImageList(r.data)
                    }
                })
            }
        } else if(e === "follow"){
            if(followList.length === 0){
                if(followPage > 1){
                    getFollowList(userId,1).then(r => {
                        if(r.result){
                            setFollowList(r.data.concat([]))
                        } else {
                            setFollowList([].concat([]))
                        }
                    })
                }
            }
        } else if(e === "follower"){
            if(followerList.length === 0){
                if(followerPage > 1){
                    getFollowerList(userId,1).then(r => {
                        if(r.result){
                            setFollowerList(r.data)
                        } else {
                            setFollowerList([].concat())
                        }
                    })
                }
            }
        } else if(e === "plans"){
            if(planList.length === 0){
                getPlanList(userId).then(r => {
                    if(r.result){
                        setPlanList(r.data)
                    } else {
                        setPlanList([].concat())
                    }
                })
            }
        }
    }

    // 削除ボタン
    let okButton
    if(!okButtonShow){
        okButton = ""
    } else {
        okButton = <Button onClick={() => {
            setShow(false)
            if(item.type === "follow"){
                followDelete(userInfo.user_id,dialog).then(r=>{
                    if(r){
                        setFollow(false)
                    }
                    setOkButtonShow(false)
                })
            } else if(item.type === "community_image"){
                deleteCommunityImage(item.id).then(r=>{
                    if(r.result){
                        setDeleted(item.id)

                        getCommunityImageList(userId,1).then(r=>{
                            if(r.result){
                                if(r.data.length > 0){
                                    setCommunityMessage("")
                                } else {
                                    setCommunityMessage("投稿がありません。")
                                }
                                setCommunityImageList(r.data)
                            }
                        })
                    } else {
                        setOkButtonShow(false)
                        dialog("エラー",r.errors)
                    }
                })
            }
        }}>OK</Button>
    }
    let followButton
    /**
     * 以下の場合フォローボタンを表示しない
     * 投稿者本人の場合
     * 投稿者が匿名の場合
     */
    if(!(loginInfo.userId === userInfo.user_id) && userInfo.user_id !== "anonymous"){
        if(follow){
            followButton = <MuiButton className='mb-2' variant='outlined' color="error" onClick={(e) => {
                selectItem({type:"follow"})
                setOkButtonShow(true)
                dialog("確認","フォローを解除しますか？")
            }}>フォロー済み</MuiButton>
        } else {
            followButton = <MuiButton className='mb-2' variant='contained' color="error" onClick={(e) => {
                if(loginInfo.userId === userInfo.user_id){
                    dialog("エラー","自分自身はフォローできません。")
                    return
                }
                followPost(userInfo.user_id,dialog).then(r=>{
                    if(r){
                        setFollow(true)
                    }
                })
            }}>フォローする</MuiButton>
        }
    }
    function seriesUpdateHandler(seriesId){
        // シリーズ
        getSeriesList(userId).then(r => {
            if(r.result){
                setSeriesList(r.data)
            }
        })
    }
    const [seriesId,setSeriesId] = useState()
    const [showShowSeriesEdit,setShowSeriesEdit] = useState(false)
    const [seriesList,setSeriesList] = useState([])
    const [showPointSend,setShowPointSend] = useState(false)

    // 管理用
    const [adminSelectItem,setAdminSelectItem] = useState("account_suspend")
    const tagReplace = (node) => {
        if (node.name === 'span' && node.attribs.tag !== undefined) {
          return (
            <span {...node.attribs} onClick={() => navigate("/search_users?tag="+node.attribs.tag)} style={{color:"#00AAFF",cursor:"pointer"}}>
              #{ domToReact(node.children) }
            </span>
          )
        }
        if (node.name === 'span' && node.attribs.href !== undefined) {
            return (
              <span {...node.attribs} onClick={() => navigate("/image/"+node.attribs.href)} style={{color:"#00AAFF",cursor:"pointer"}}>
                { domToReact(node.children) }
              </span>
            )
        }
        if (node.name === 'a') {
            return (
              <a href={"/jump/" + encodeURIComponent(node.attribs.href)}>{node.attribs.href}</a>
            )
        }
    }
    const [aIAssistant,setAIAssistant] = useState(false)
    return(
    <div className="wrapper" style={{backgroundColor:"#EEEEEE"}}>
        <header className="App-header"></header>
        <CommonDialog open={aIAssistant} onClose={() => setAIAssistant(false)} content={<AITalk characterId={userIdOrDisplayId} characterName={characterInfo.character_name} show={true} dialog={dialog} setPoint={() => {}} setAIAssistant={setAIAssistant} />} fullScreen={true} />
        {showSetting ? (<SettingPopup switch={setShowSetting} />) : ""}
        {showRankingRecord ? (<RankingRecordPopup switch={setShowRankingRecord} userId={userId} />) : ""}
        {showShowSeriesEdit ? <SeriesEditPopup switch={setShowSeriesEdit} seriesId={seriesId} onUpdate={seriesUpdateHandler} /> : ""}
        {showPointSend ? <PointSend userId={userInfo.user_id} userName={userInfo.user_name} dialog={dialog} switch={setShowPointSend} /> : ""}
        {showEditPopup ? <CharacterEditPopup switch={setShowEditPopup} groupId={userIdOrDisplayId} /> : ""}
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} button={okButton} />
        <Header />
        <Category />
        {false && loginInfo.role && loginInfo.role.find(d => d.role_div === "admin" || d.role_div === "moderator") ? (
            <Container style={{width:"400px",border:"1px solid red"}} className="mb-3 p-3">
                <Form.Select className="mb-3" value={adminSelectItem} style={{}}
                    onChange={(e) => setAdminSelectItem(e.currentTarget.value)}
                >
                    <option value="アカウント" disabled>【アカウント】</option>
                    <option value="ai_generate_suspend" style={{color:"red"}}>AI生成機能の利用制限措置</option>
                    <option value="account_suspend" style={{color:"red"}}>一時停止(利用規約違反)</option>
                    <option value="account_suspend_child_porn_post" style={{color:"red"}}>一時停止(児童ポルノまたは類似物の投稿)</option>
                    <option value="account_suspend_child_porn_generate" style={{color:"red"}}>一時停止(児童ポルノまたは類似物の生成)</option>
                    <option value="account_suspend_copyright" style={{color:"red"}}>一時停止(著作権侵害)</option>
                    <option value="account_permanently_frozen" style={{color:"red"}}>永久凍結</option>
                </Form.Select>
                <MuiButton  variant='contained' style={{}}
                    onClick={(e) => {
                        if(adminSelectItem !== "ai_generate_suspend"){
                            let status = -1
                            let reason = -1
                            if(adminSelectItem === "account_suspend"){
                                status = 3 // 一時停止
                                reason = 1 // 利用規約違反
                            } else if(adminSelectItem === "account_suspend_child_porn_post"){
                                status = 3 // 一時停止
                                reason = 2 // 写実的な児童ポルノコンテンツの投稿
                            } else if(adminSelectItem === "account_suspend_child_porn_generate"){
                                status = 3 // 一時停止
                                reason = 3 // 写実的な児童ポルノコンテンツの生成
                            } else if(adminSelectItem === "account_suspend_copyright"){
                                status = 3 // 一時停止
                                reason = 4 // 著作権侵害
                            } else if(adminSelectItem === "account_permanently_frozen") {
                                status = 4 // 永久凍結
                            }
                            updateStatusByAdmin(userInfo.user_id,status,reason).then(r => {
                                if(r.result){
                                    dialog("確認","アカウントを「"+r.data.accountReturn+"」しました。")
                                } else {
                                    dialog("エラー",r.errors)
                                }
                            })
                        }
                        if(adminSelectItem === "ai_generate_suspend"){
                            aiGenerateSuspendByAdmin(userInfo.user_id).then(r => {
                                if(r.result){
                                    dialog("確認","AI生成機能の利用を制限しました。")
                                } else {
                                    dialog("エラー",r.errors)
                                }
                            })
                        }
                        
                    }}
                >実行(管理者権限)</MuiButton>
                <MuiButton variant='contained' style={{marginLeft:"10px"}} onClick={() => dialog("統計情報",<UserManageInfo userIdOrDisplayId={userInfo.user_id} dialog={dialog} change={userInfo.user_id} />)}>管理情報</MuiButton>
            </Container>
        ) : ""}
        <Row>
            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto"}}>
                <div className="p-3 mt-0">
                    <Container className="d-block p-0" style={{backgroundColor:"#FFFFFF",borderRadius:"20px"}}>
                        <div style={{overflow:"hidden",margin:"0 auto -100px auto",borderRadius:"20px 20px 0 0"}}>
                            <Image src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/character/post/t/"+userIdOrDisplayId+"_out.webp?"+characterInfo.hash} style={{objectFit:"cover",width:"100%",height:"100%",maxHeight:"400px"}} />
                        </div>
                        <div xs={4} sm={4} md={3} lg={2} xl={2} xxl={2} style={{position:"relative",height:"220px"}} className='p-3'>
                            {loginInfo.userId === characterInfo.user_id ? (
                                <><Chip style={{position:"absolute",zIndex:1,backgroundColor:"#FFFFFF",bottom:"130px",left:"6px"}} label={<Icon.GearWide style={{fontSize:"24px"}} />} onClick={() => setShowEditPopup(true)} disabled={loginInfo.result && loginInfo.status !== 0} />&nbsp;</>
                            ) : ""}
                            <Image src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/character/post/t/"+userIdOrDisplayId+"_in.webp?"+characterInfo.hash}
                                style={{position:"absolute",top:"60px",left:"0px",marginLeft:"20px",width:"150px",height:"auto",borderRadius:"10%",border:"3px solid #FFFFFF"}} />
                            <div style={{fontSize:"16px",fontWeight:"bold",position:"absolute",top:"110px",left:"180px"}}>
                                <span style={{fontSize:"24px"}}>{characterInfo.character_name_kana !== "" ? <ruby> {characterInfo.character_name} <rp>(</rp><rt>{characterInfo.character_name_kana}</rt><rp>)</rp> </ruby> : characterInfo.character_name}</span>
                                &nbsp;<span style={{fontSize:"14px",color:"#555555"}}>作者:<Link to={"/user/"+(characterInfo.display_id !== "" ? characterInfo.display_id : characterInfo.user_id)}>{characterInfo.user_name}</Link></span>
                                <UserMark sms_auth={userInfo.sms_auth} role={userInfo.role} plan={userInfo.plan} beginner={userInfo.beginner} identity_confirmed={userInfo.identity_confirmed} moderator_badge_display_flag={userInfo.moderator_badge_display_flag} dialog={dialog} />
                                &nbsp;{userInfo.isFollowed === 1 ? <span style={{fontSize:"12px",color:"#555555",backgroundColor:"#DDDDDD",borderRadius:"5px",padding:"2px"}}>フォローされています</span> : ""}
                                {false ? <>&nbsp;<Chip className='d-' label={"支援中"} color='info' style={{fontSize:"14px",height:"24px",position:"absolute",top:"-30px",left:0}} /></> : ""}
                                <br />{characterInfo.fanart === 1 && characterInfo.fanart_hash_tag !== "" ? <div style={{color:"#777777"}}>ファンアートタグ：<Link to={"/tag/"+characterInfo.fanart_hash_tag+"/1"} style={{textDecoration:"none"}}><span style={{fontWeight:"normal"}}>#{characterInfo.fanart_hash_tag}</span></Link></div> : ""}
                                <div className='mt-2'>
                                    {characterInfo.description !== undefined /*&& (characterInfo.age_limit === 1 || characterInfo.age_limit === 2)*/ ? (
                                        <><Chip label={<MailOutlineIcon />} onClick={() => {
                                            //setAIAssistant(true)
                                            navigate("/aitalk/"+userIdOrDisplayId)
                                        }} disabled={characterInfo.description.replace("-","").length < 100} /> &nbsp;</>
                                    ): ""}
                                    {characterInfo.fanart === 1 ? (
                                        <Chip label={<>ファンアート <span style={{color:"green"}}>OK</span></>} />
                                    ) : characterInfo.fanart === 0 ? <Chip label={<>ファンアート <span style={{color:"red"}}>NG</span></>} /> : ""}&nbsp;
                                    {characterDetail.length > 0 && (characterDetail[0].prompt.length > 0 || characterDetail[0].negative_prompt.length > 0) ? (
                                        <><Chip label="プロンプトを確認" onClick={() => {
                                            setShowPrompt(true)
                                        }} /> &nbsp;</>
                                    ): ""}
                                </div>
                                <CommonDialog content={<>
                                    <TextField
                                        label="プロンプト"
                                        id="prompt"
                                        sx={{ m: 1, width: '25ch' }}
                                        value={characterDetail.length > 0 ? characterDetail[0].prompt : ""}
                                    />
                                    <CopyToClipboardButton text={characterDetail.length > 0 ? characterDetail[0].prompt : ""} />
                                    <br />
                                    <TextField
                                        label="ネガティブプロンプト"
                                        id="negative-prompt"
                                        sx={{ m: 1, width: '25ch' }}
                                        value={characterDetail.length > 0 ? characterDetail[0].negative_prompt : ""}
                                    />
                                    <CopyToClipboardButton text={characterDetail.length > 0 ? characterDetail[0].negative_prompt : ""} />
                                </>} open={showPrompt} onClose={() => setShowPrompt(false)} onClick={() => setShowPrompt(false)} />
                            </div>
                            <div style={{position:"absolute",top:"210px",left:"12px"}}>
                                <Chip className='m-1 d-none' onClick={() => setShowUserAchievements(true)} label={<span><Icon.TrophyFill />&nbsp;{t("common.trackRecord")} </span>} />
                                <Link to={link} target="_blank"><Chip style={{backgroundColor:"#000000",border:"1px solid #555555"}} label={<span style={{textDecoration:"none",color:"#FFFFFF"}}>𝕏 Post</span>} /></Link>
                                {true ? "" : <>{userInfo.id_auth === 1 ? <> <span style={{fontSize:"12px",backgroundColor:"#EEEEEE"}} className='p-1'><Icon.CheckCircle style={{color:"green"}} /> 本人確認済</span></> : <> <span style={{fontSize:"12px",backgroundColor:"#EEEEEE"}} className='p-1'><Icon.CheckCircle style={{color:"grey"}} /> 本人確認未提出</span></>}</>}
                            </div>
                        </div>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{margin:"0 auto",padding:"20px 20px 4px 20px"}}>
                            <div style={{position:"relative"}}>
                                <div className='mb-3 d-none d-xl-block' style={{position:"absolute",right:"0px",top:"-100px"}}>
                                    {characterInfo.misskey_id !== undefined && characterInfo.misskey_id !== "" ? (<><Link to={"https://sns.ourt-ai.work/@"+characterInfo.misskey_id} target="_blank"><Chip className="m-0" style={{height:"24px"}} label={<Image src="/img/misskey.png" width="24px" />} /></Link></>) : ""}
                                    {characterInfo.homepage !== undefined && characterInfo.homepage !== "" ? (<>&nbsp;<Link to={characterInfo.homepage} target="_blank"><Chip style={{height:"24px",fontSize:"20px"}} className="m-0" label={<Icon.Link />} /></Link></>) : ""}
                                    {characterInfo.x_id !== undefined && characterInfo.x_id !== "" ? (<>&nbsp;<Link to={"https://x.com/"+characterInfo.x_id} target="_blank"><Chip style={{height:"24px",fontSize:"20px"}} className="m-0" label={"𝕏"} /></Link></>) : ""}
                                    {characterInfo.youtube_id !== undefined && characterInfo.youtube_id !== "" ? (<>&nbsp;<Link to={"https://www.youtube.com/@"+characterInfo.youtube_id} target="_blank"><Chip style={{height:"24px",fontSize:"20px"}} className="m-0" label={<Icon.Youtube />} /></Link></>) : ""}
                                    {characterInfo.discord_user_name !== undefined && characterInfo.discord_user_name !== "" ? (<>&nbsp;<Chip style={{height:"24px",fontSize:"20px"}} className="m-0" label={<Icon.Discord />} onClick={() => dialog("",characterInfo.discord_user_name)} /></>) : ""}
                                    {characterInfo.instagram_id !== undefined && characterInfo.instagram_id !== "" ? (<>&nbsp;<Link to={"https://www.instagram.com/"+characterInfo.instagram_id} target="_blank"><Chip style={{height:"24px",fontSize:"20px"}} className="m-0" label={<Icon.Instagram />} /></Link></>) : ""}
                                    {characterInfo.tiktok_id !== undefined && characterInfo.tiktok_id !== "" ? (<>&nbsp;<Link to={"https://www.tiktok.com/@"+characterInfo.tiktok_id} target="_blank"><Chip style={{height:"24px",fontSize:"20px"}} className="m-0" label={<Icon.Tiktok />} /></Link></>) : ""}
                                    {characterInfo.github_id !== undefined && characterInfo.github_id !== "" ? (<>&nbsp;<Link to={"https://github.com/"+characterInfo.github_id} target="_blank"><Chip style={{height:"24px",fontSize:"20px"}} className="m-0" label={<Icon.Github />} /></Link></>) : ""}
                                    {characterInfo.huggingface_id !== undefined && characterInfo.huggingface_id !== "" ? (<>&nbsp;<Link to={"https://huggingface.co/"+characterInfo.huggingface_id} target="_blank"><Chip style={{height:"24px",fontSize:"20px"}} className="m-0" label={"🤗"} /></Link></>) : ""}
                                    &nbsp;
                                    {/*followButton*/}
                                    &nbsp;
                                    {/*loginInfo.userId === userInfo.user_id || userInfo.user_id === "anonymous" ? "" : (
                                        <>
                                        <Button className='mb-2' variant='outline-danger' title='支援する'
                                        onClick={() => setShowPointSend(true)}
                                        ><Icon.PersonHeart style={{fontSize:"24px"}} /></Button>
                                        <br />
                                        </>
                                    )*/}
                                    {loginInfo.length === undefined && loginInfo.userId === userInfo.user_id && loginInfo.displayId === "" ? <p><span onClick={() => setShowSetting(true)} style={{cursor:"pointer",textDecoration:"underline"}}>表示IDを設定</span>することでこのページへのリンク「/user/xxxx」を変更できます。</p> : ""}
                                </div>
                                <div className='d-none d-xl-block' style={{marginTop:"20px"}}></div>
                                <div className='mb-3 d-block d-xl-none' style={{marginTop:"20px"}}>
                                    {characterInfo.misskey_id !== undefined && characterInfo.misskey_id !== "" ? (<><Link to={"https://sns.ourt-ai.work/@"+characterInfo.misskey_id} target="_blank"><Chip className="m-0" style={{height:"24px"}} label={<Image src="/img/misskey.png" width="24px" />} /></Link></>) : ""}
                                    {characterInfo.homepage !== undefined && characterInfo.homepage !== "" ? (<>&nbsp;<Link to={characterInfo.homepage} target="_blank"><Chip style={{height:"24px",fontSize:"20px"}} className="m-0" label={<Icon.Link />} /></Link></>) : ""}
                                    {characterInfo.x_id !== undefined && characterInfo.x_id !== "" ? (<>&nbsp;<Link to={"https://x.com/"+characterInfo.x_id} target="_blank"><Chip style={{height:"24px",fontSize:"20px"}} className="m-0" label={"𝕏"} /></Link></>) : ""}
                                    {characterInfo.youtube_id !== undefined && characterInfo.youtube_id !== "" ? (<>&nbsp;<Link to={"https://www.youtube.com/@"+characterInfo.youtube_id} target="_blank"><Chip style={{height:"24px",fontSize:"20px"}} className="m-0" label={<Icon.Youtube />} /></Link></>) : ""}
                                    {characterInfo.discord_user_name !== undefined && characterInfo.discord_user_name !== "" ? (<>&nbsp;<Chip style={{height:"24px",fontSize:"20px"}} className="m-0" label={<Icon.Discord />} onClick={() => dialog("",characterInfo.discord_user_name)} /></>) : ""}
                                    {characterInfo.instagram_id !== undefined && characterInfo.instagram_id !== "" ? (<>&nbsp;<Link to={"https://www.instagram.com/"+characterInfo.instagram_id} target="_blank"><Chip style={{height:"24px",fontSize:"20px"}} className="m-0" label={<Icon.Instagram />} /></Link></>) : ""}
                                    {characterInfo.tiktok_id !== undefined && characterInfo.tiktok_id !== "" ? (<>&nbsp;<Link to={"https://www.tiktok.com/@"+characterInfo.tiktok_id} target="_blank"><Chip style={{height:"24px",fontSize:"20px"}} className="m-0" label={<Icon.Tiktok />} /></Link></>) : ""}
                                    {characterInfo.github_id !== undefined && characterInfo.github_id !== "" ? (<>&nbsp;<Link to={"https://github.com/"+characterInfo.github_id} target="_blank"><Chip style={{height:"24px",fontSize:"20px"}} className="m-0" label={<Icon.Github />} /></Link></>) : ""}
                                    {characterInfo.huggingface_id !== undefined && characterInfo.huggingface_id !== "" ? (<>&nbsp;<Link to={"https://huggingface.co/"+characterInfo.huggingface_id} target="_blank"><Chip style={{height:"24px",fontSize:"20px"}} className="m-0" label={"🤗"} /></Link></>) : ""}
                                    &nbsp;
                                    {/*followButton*/}
                                    &nbsp;
                                    {/*loginInfo.userId === userInfo.user_id || userInfo.user_id === "anonymous" ? "" : (
                                        <>
                                        <Button className='mb-2' variant='outline-danger' title='支援する'
                                        onClick={() => setShowPointSend(true)}
                                        ><Icon.PersonHeart style={{fontSize:"24px"}} /></Button>
                                        <br />
                                        </>
                                    )*/}
                                    {loginInfo.length === undefined && loginInfo.userId === userInfo.user_id && loginInfo.displayId === "" ? <p><span onClick={() => setShowSetting(true)} style={{cursor:"pointer",textDecoration:"underline"}}>表示IDを設定</span>することでこのページへのリンク「/user/xxxx」を変更できます。</p> : ""}
                                </div>
                                <MuiButton className='d-none' variant="outlined" onClick={() => navigate("/user/" + (userInfo.display_id !== "" ? userInfo.display_id : userInfo.user_id) +"/best/2023")}>2023年振り返り</MuiButton>
                                <p className='d-none'><span style={{fontWeight:"bold"}}>{followCount}</span> 投稿&nbsp;&nbsp;<span style={{fontWeight:"bold"}}>{followerCount}</span> いいね</p>
                                <MuiButton variant='outlined'
                                onClick={() => {
                                    refererUser(userId).then(r => {
                                        if(r.result){
                                            navigate("/regist-select")
                                        }
                                    })
                                }}
                                className='mb-3 d-none'
                                disabled={!(loginInfo.result === false && userInfo.sms_auth === 1)}
                                >招待を受けて登録</MuiButton>
                                <Icon.QuestionCircle style={{marginLeft:"10px",fontSize:"20px",cursor:"pointer",display:"none"}} 
                                onClick={() => {
                                    dialog("招待制度について",
                                    <Container>
                                        利用者の招待を受けて登録することで、<br />
                                        招待した人、招待された人の両者に特典が付与される制度です。<br /><br />
                                        2段階に分けて特典が付与されます。<br /><br />
                                        ①招待を受けてユーザー登録後にSMS認証することで、両者に2000ポイント<br />
                                        ②招待された利用者が、10投稿以上行うことで、両者に3000ポイント<br /><br />
                                        ■招待するために必要なこと<br />
                                        ・招待する側<br />
                                        招待する利用者はSMS認証完了することで、マイページの招待ボタンがクリックできるようになります。<br />
                                        ・招待される側<br />
                                        招待者のマイページにある「招待を受けて登録」ボタンから登録します。
                                    </Container>
                                    )
                                }}
                                />
                                <CommonDialog title={<><Icon.TrophyFill style={{fontSize:"18px"}} />&nbsp;{t("common.trackRecord")}</>} open={showUserAchievements} content={
                                    <>
                                        {t("user.postingCount")}：<b>{imageCount}</b><br />
                                        {t("user.postingCount")}(Images)：<b>{imageDetailCount}</b><br />
                                        {t("user.views")}：<b>{pvAllCount}</b><br />
                                        {t("user.favoritedCount")}：<b>{(favoritedCount || "").toLocaleString()}</b><br />
                                        {t("user.favoriteCount")}：<b>{(favoriteCount || "").toLocaleString()}</b><br />
                                        {t("user.last3MonthAvgPV")}：<b>{pv3MonthCount}({t("user.rank")}：{pv3MonthRank})</b><br />
                                        {t("user.last3MonthAvgFavorite")}：<b>{favorite3MonthCount}</b><br />
                                        <hr />
                                        {t("user.getPoint")}：<b>{postGetPoint}</b> / 1枚<br />
                                        {t("user.hasPoint")}：<Icon.Gem style={{color:"#0000FF"}}/> <b>{(point || "").toLocaleString()}</b><br />
                                        {t("user.totalPointUsed")}：<Icon.Gem style={{color:"#0000FF"}}/> <b>{(totalPointsUsed || "").toLocaleString()}</b><br />
                                        {t("user.imageGenerationCount")}: <b>{(imageGenrationCount || "").toLocaleString()}</b><br />
                                        {t("user.basePoint")}：<Icon.Gem style={{color:"#0000FF"}}/> <b>{(basePoint || "").toLocaleString()}</b>
                                        <hr />
                                        {t("user.numberOfUnitsUnderOperation")}：<RIcon.FaMoneyBill /> <b>{parseInt(numberOfUnitsUnderOperation).toLocaleString()}</b>
                                        <hr />
                                        <MuiButton variant='outlined' onClick={() => {
                                            setShowUserAchievements(false)
                                            setShowRankingRecord(true)
                                        }}>{t("rankingRecord.title")}</MuiButton>
                                    </>
                                } onClick={() => {

                                }} onClose={() => {
                                    setShowUserAchievements(false)
                                }} />
                            </div>
                        </Col>
                    </Container>
                </div>
            </Col>
        </Row>
        {loginInfo.plan === undefined || loginInfo.plan === "basic" || loginInfo.plan === "certification" || loginInfo.plan === "unlimited" || loginInfo.plan === "plus" ? "" : <>
            <Container className='text-center'><div style={{border:"1px solid #BBBBBB",borderRadius:"6px"}} className='d-inline-block p-2'><Link to="/upload/image/generate" className=''>画像生成してみよう！<br /><Image src="/img/generate_512x256.webp" width={240} /></Link></div></Container>
        </>}
        {showViewPopup ? <CharacterViewPopup groupId={userIdOrDisplayId} switch={setShowViewPopup} i={0} /> : ""}
        <div className='p-0' style={{backgroundColor:"#FFFFFF"}}>
            <Tabs defaultActiveKey={isMe ? "account" : "osusume"} activeKey={tabKey} className="mt-3 mb-3 w-100 d-flex" onSelect={(e)=>handleTabSelect(e)}>
                <Tab eventKey={"profile"} title="プロフィール" className='p-3'>
                    <p style={{font:"inherit",wordBreak:"break-all",wordWrap:"break-word",whiteSpace:"pre"}}>{characterInfo.character_name ? parse(characterInfo.description.replace(/\n|\r\n|\r/g,'<br/ >').replace(/(https?:\/\/[\w!?/+\-_~;.,*&@#$%()'[\]]+)/g,'<a href="$1">$1</a>').replace(/[#＃]{1}([Ａ-Ｚａ-ｚA-Za-z一-鿆0-9０-９ぁ-ヶｦ-ﾟー._-・]?[^　#＃\r\n]+)/g,'<span tag="$1">$1</span>'),{replace:tagReplace}) : ""}</p>
                    <Table striped bordered hover style={{width:"auto"}}>
                        <tbody>
                            <tr><td>性別：</td><td>{getSex(characterInfo.character_sex)}</td></tr>
                            {characterInfo.character_birthday !== "00-00" ? <tr><td>誕生日：</td><td>{characterInfo.character_birthday}</td></tr> : ""}
                            {characterInfo.character_age !== "" ? <tr><td>年齢：</td><td>{characterInfo.character_age}</td></tr> : ""}
                            {characterInfo.hobby !== "" ? <tr><td>趣味：</td><td>{characterInfo.hobby}</td></tr> : ""}
                            <tr><td>作者：</td><td><Link to={"/user/"+characterInfo.user_id}>{characterInfo.user_name}</Link></td></tr>
                        </tbody>
                    </Table>
                    <div className='d-flex flex-row justify-content-start flex-wrap w-100 p-0'>
                        {characterDetail.map((data,i) => {
                            return <div style={{width:"180px",height:"180px",cursor:"pointer"}} className='m-3'
                            onClick={() => {
                                setShowViewPopup(true)
                            }}
                            ><Image src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST + '/character/post/t/'+(data.id)+ApiFetch.API_THUMB_EXT} style={{objectFit:"cover",width:"100%",height:"100%"}} /></div>
                        })}
                    </div>
                </Tab>
                <Tab eventKey={"notes"} title={"ガイドライン"} className='p-3' style={{whiteSpace:"pre"}}>
                    {characterInfo.notes}
                </Tab>
                {true || isMe || loginInfo.userId === undefined ? "" : (
                <Tab eventKey="osusume" title={t("osusume.title")}>
                    <div className='d-flex flex-row justify-content-start flex-wrap w-100 p-0'>
                        {osusumeImageList.map((data,i) => {
                            if(i === 100 || data.favorite === 1){
                                return ""
                            }
                        return <Thumb data={data} i={i} dialog={dialog} key={i} userInfoHidden={true} list={osusumeImageList} listName={userInfo.user_name} />
                        })}
                    </div>
                </Tab>
                )}
                <Tab eventKey="account" title={t("common.illust")}>
                    <Form.Select style={{width:"200px"}} className="m-1 d-inline" value={order} onChange={(e) => {
                            setOrder(e.currentTarget.value)
                        }}>
                        <option value="favorite_desc">いいね多い順</option>
                        <option value="pv_desc">閲覧数多い順</option>
                        <option value="post_desc">投稿日新しい順</option>
                        <option value="post_asc">投稿日古い順</option>
                    </Form.Select>
                    <FormGroup className='d-inline'>
                        <FormControlLabel control={<Checkbox onChange={(e) => setUnitSell(e.currentTarget.checked)} />} label="単品販売" />
                        <FormControlLabel control={<Checkbox onChange={(e) => setMembership(e.currentTarget.checked)} />} label="メンバーシップ" />
                    </FormGroup>
                    <MuiButton variant='outlined' className='m-1' onClick={() => setPage(1)}>1ページ目へ</MuiButton>
                    <div className='d-flex flex-row justify-content-start flex-wrap w-100 p-0'>
                        {message}
                        {imageList.filter(d => {
                            if(!unitSell && !membership) return true
                            if(unitSell && d.unit_amount > 0) return true
                            if(membership && d.limit_div !== "public") return true
                        }).map((data,i) => {
                            if(i === 100){
                                return ""
                            }
                        return <Thumb data={data} i={i} dialog={dialog} key={i} userInfoHidden={true} list={imageList} listName={userInfo.user_name} />
                        })}
                    </div>
                    <Container className='d-flex justify-content-between' style={{width:"200px"}}>
                        {page > 1 ? (
                                <MuiButton variant='contained' onClick={() => {
                                    let p = page - 1
                                    setPage(p)
                                    //navigate("/user/" + userId + "/" + order + "/" + p)
                                    getImageList(userId,order,p)
                                } }>{t("common.prev")}</MuiButton>
                            ) : <MuiButton variant='contained' disabled>{t("common.prev")}</MuiButton>}
                        {imageList.length > 100 ? (
                                <MuiButton variant='contained' onClick={() => {
                                    let p = page + 1
                                    setPage(p)
                                    //navigate("/user/" + userId + "/" + order + "/" + p)
                                    getImageList(userId,order,p)
                                } }>{t("common.next")}</MuiButton>
                            ) : <MuiButton variant='contained' disabled>{t("common.next")}</MuiButton>}
                    </Container>
                </Tab>
                {false ? <Tab eventKey="series" title={t("common.series")}>
                    {loginInfo.result && userInfo.user_id === loginInfo.userId ? (
                        <MuiButton variant='contained' onClick={() => {
                            setSeriesId()
                            setShowSeriesEdit(true)
                        }}>シリーズを追加する</MuiButton>
                    ) : ""}
                    <Row>
                    {seriesList.map((d,i) => {
                        let ageLimit = ["全年齢","PG12","R15","R18","R18G"]
                        let id = d.info.display_id.length > 0 ? d.info.display_id : d.info.user_id
                        return  <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="p-1" key={i}>
                                    <Container className="p-3" style={{border:"1px solid #CCCCCC",borderRadius:"5px"}}>
                                        <div className='d-flex justify-content-start'>
                                            <div>
                                                <div style={{position:"relative"}}>
                                                    {loginInfo.userId === userInfo.user_id ? (
                                                        <div>
                                                            <Button variant='secondary'
                                                                onClick={() => {
                                                                    setSeriesId(d.info.series_id)
                                                                    setShowSeriesEdit(true)
                                                                }}
                                                            style={{position:"absolute",right:"60px",top:"10px"}}>編集</Button>
                                                            <Button variant='secondary'
                                                                onClick={() => {
                                                                    deleteSeries(d.info.series_id).then(r => {
                                                                        if(r.result){
                                                                            dialog(t("common.confirm"),t("common.deleted"))
                                                                            seriesUpdateHandler()
                                                                        } else {
                                                                            dialog(t("common.error"),r.errors)
                                                                        }
                                                                    })
                                                                }}
                                                            style={{position:"absolute",right:"10px",top:"10px"}}><Icon.TrashFill /></Button>
                                                        </div>
                                                    ) : ""}
                                                    <Link to={"/series/"+id+"/"+d.info.series_link}>
                                                        <Image data-type="series" data-observe="0" data-no={i} className="lazy" loading="lazy" src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/series/"+d.info.series_id+".webp?"+d.info.update_datetime} style={{width:"300px",height:"auto",borderRadius:"5px"}} />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div style={{marginLeft:"10px"}}>{d.info.series_name}<br />
                                            {parse(d.info.series_description.substring(0,50).replace(/\r|\n|\r\n/g,"<br/>"),{})}<br /><br />
                                            年齢制限：{ageLimit[d.info.series_age_limit-1]}<br />
                                            </div>
                                        </div>
                                    </Container>
                                </Col>
                    })}
                    </Row>
                </Tab> : ""}
                {false ? <Tab eventKey="community" title={t("common.community")}>
                    <Container style={{display:loginInfo.userId === userId ? "block" : "none"}}>
                        <div style={{display:"inline-block",border:"1px solid #AAAAAA",borderRadius:"5px",textAlign:"left",padding:"10px 5px",marginBottom:"10px"}}>
                            <FloatingLabel controlId="text" label="お知らせや進捗状況、告知など" className='mb-3 w-100' style={{lineHeight:"20px"}} onInput={(e) =>{
                                let lineHeight = e.currentTarget.style.lineHeight.replace(/[^0-9.]+/,'')
                                let n = e.nativeEvent.target.value.match(/\n/g)
                                if(n === null){
                                    n = 1
                                } else {
                                    n = n.length + 1
                                }
                                e.currentTarget.style.height = lineHeight * n + 30 + "px"
                                document.querySelector(".textarea").style.height = lineHeight * n + 30 + "px"
                            }}>
                                <Form.Control
                                    className='textarea'
                                    as="textarea"
                                    style={{ width:"360px",height: '50px' }}
                                    required
                                />
                            </FloatingLabel>
                            <Form.Control type="file" encType="multipart/form-data" accept=".jpg,.jpeg,.gif,.png,.webp" className='d-none' id="file" onChange={(e) => {
                                if(e.currentTarget.files.length > 0){
                                    ImageUtil.loadImage(e.currentTarget.files,setCommunityImage,false)
                                }
                            }} />
                            <Container id="img-area" style={{width:"300px"}}>
                                {communityImage !== "" ? (<Image src={communityImage} style={{objectFit:"contain",width:"100%",height:"100%",boxSizing:"content-box"}} />):""}
                            </Container>
                            <Container>
                                <Button onClick={() => {
                                    setOkButtonShow(false)
                                    let text = document.getElementById("text")
                                    let files = document.getElementById("file").files
                                    if(text.value.trim().length === 0){
                                        dialog("エラー","本文を入力して下さい。")
                                        return
                                    }
                                    if(text.value.trim().length > 2500){
                                        dialog("エラー","本文は2500文字以内にして下さい。")
                                        return
                                    }
                                    if(files.length !== 0){
                                        // ファイルサイズチェック
                                        if(files[0].size > 31457280){
                                            dialog("エラー","ファイルサイズ上限は30MBです。")
                                            return
                                        }
                                    }
                                    upload(document.getElementById("file").files)
                                }}>投稿</Button>
                                <Icon.Image style={{cursor:"pointer",marginLeft:"10px"}} onClick={() => document.getElementById("file").click()} />
                            </Container>
                        </div>
                        <hr />
                    </Container>
                    <Container>
                    {communityMessage}
                    {communityImageList.map((d,i)=>{
                        return (
                        <div style={{width:"360px",border:"1px solid #AAAAAA",borderRadius:"5px",textAlign:"left",padding:"10px",marginBottom:"10px"}} key={i}>
                            <Row>
                                <Col xs={2}>
                                    <Image loading="lazy" src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/profile/"+d.user_id+"_s.jpg"} style={{width:"50px",height:"50px",borderRadius:"25px",marginRight:"30px"}} />
                                </Col>
                                <Col style={{position:"relative"}}>
                                    {(loginInfo.userId === d.user_id)? (
                                        <CloseButton style={{position:"absolute",zIndex:"1",top:"0px",right:"20px",fontSize:"12px"}} onClick={()=>{
                                            selectItem({type:"community_image",id:d.group_id})
                                            setOkButtonShow(true)
                                            dialog("確認","削除しますか？")
                                        }}></CloseButton>
                                    ) : ""}
                                    <Container style={{fontSize:"14px",marginBottom:"5px"}}>{d.user_name}</Container>
                                    <Container style={{whiteSpace: "pre-wrap"}}>{d.text}</Container>
                                    <Container style={{width:"100%",margin:"auto"}}>
                                        <Image data-type="community" data-no={i} className="lazy" loading="lazy" src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/community/t/'+(d.id)+'.jpg'} style={{objectFit:"contain",width:"100%",cursor:"pointer"}} onClick={() => navigate("/post/"+d.group_id)} />
                                    </Container>
                                    <Container>
                                        <FavoriteIcon style={{cursor:"pointer"}} type="community" id={d.group_id} favorite={d.favorite} dialog={dialog} />
                                        <Icon.ChatRightText style={{cursor:"pointer"}} onClick={() => navigate("/post/"+d.group_id)} />
                                        &nbsp;{d.favorite_count !== 0 ? d.favorite_count : ""}
                                    </Container>
                                </Col>
                            </Row>
                        </div>
                        )
                    })}
                    </Container>
                </Tab> : ""}
                {false ? <Tab eventKey="follow" title={t("common.follow")}>
                    <Row>
                    {followList.map((d,i) => {
                        return  <Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="p-1" key={i}>
                                    <Container className="p-3" style={{border:"1px solid #CCCCCC",borderRadius:"5px"}}>
                                        <div className='d-flex justify-content-start'>
                                            <div>
                                                <Link to={"/user/"+d.follow_user_id}><Image data-type="follow" data-observe="0" data-no={i} className="lazy" loading="lazy" src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/profile/"+d.follow_user_id+".jpg"} style={{width:"100px",height:"auto",borderRadius:"50%"}} /></Link>                                            
                                            </div>
                                            <div className='p-3'>
                                                <Link to={"/user/"+d.follow_user_id} style={{textDecoration:"none",color:"#000000"}}>{d.user_name}</Link>
                                                <br />
                                                {loginInfo.userId !== d.follow_user_id ? 
                                                (<FollowButton userId={d.follow_user_id} follow={d.follow} userName={d.user_name} />)
                                                : ""}
                                            </div>
                                        </div>
                                        <p>{d.self_introduction}</p>
                                    </Container>
                                </Col>
                    })}
                    </Row>
                </Tab> : ""}
                {false ? <Tab eventKey="follower" title={t("common.follower")}>
                    <Row>
                    {followerList.map((d,i) => {
                        return  <Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="p-1" key={i}>
                                    <Container className="p-3" style={{border:"1px solid #CCCCCC",borderRadius:"5px"}}>
                                        <div className='d-flex justify-content-start'>
                                            <div>
                                                <Link to={"/user/"+d.user_id}><Image data-type="follower" data-observe="0" data-no={i} className="lazy" loading="lazy" src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/profile/"+d.user_id+".jpg"} style={{width:"100px",height:"auto",borderRadius:"50%"}} /></Link>
                                            </div>
                                            <div className='p-3'>
                                                <Link to={"/user/"+d.user_id} style={{textDecoration:"none",color:"#000000"}}>{d.user_name}</Link>
                                                <br />
                                                {loginInfo.userId !== d.user_id ? 
                                                (<FollowButton userId={d.user_id} follow={d.follow} userName={d.user_name} />)
                                                : ""}
                                            </div>
                                        </div>
                                        <p>{d.self_introduction}</p>
                                    </Container>
                                </Col>
                    })}
                    </Row>
                </Tab> : ""}
                {false && userInfo.user_id !== loginInfo.userId && userInfo.id_auth === 1 || userInfo.user_id === loginInfo.userId ? (
                <Tab eventKey="plans" title="プラン">
                    <Container className='mb-4'>
                        {loginInfo.result && userInfo.user_id === loginInfo.userId ? (
                            <MuiButton variant='contained' onClick={() => {
                                navigate("/manage/plan/new")
                            }} disabled={loginInfo.bank_registed === 0 || loginInfo.id_auth === 0 || loginInfo.sms_auth === 0}>プランを作成する</MuiButton>
                        ) : ""}
                        {userInfo.user_id === loginInfo.userId
                            && (loginInfo.bank_registed === 0 || loginInfo.id_auth === 0 || loginInfo.sms_auth === 0) ? (
                            <Alert severity='info' className='mt-3 mb-3'>振込先口座設定と本人確認、SMS認証をすると、メンバーシップ機能や応援コメント機能で収益が得られるようになります。<br /><br />
                                <MuiButton onClick={() => setShowSetting(true)} variant='outlined' className='mb-1'>設定画面を開く</MuiButton><br />
                                「設定画面」→「セキュリティ」タブから行えます。<br />
                                <MuiButton variant='outlined' onClick={() => navigate("/manage/payouts")} className='mt-3'>振込口座登録と本人確認をする</MuiButton><br /><br />
                            </Alert>
                        ) : ""}
                    </Container>
                    <Container>
                        {userInfo.user_id !== loginInfo.userId &&
                            (planStatus.pg12 && loginInfo.pg12_display_flag === 2
                            || planStatus.r15 && loginInfo.r15_display_flag === 2 && loginInfo.age15 === 1
                            || planStatus.r18 && loginInfo.r18_display_flag === 2 && loginInfo.age18 === 1
                            || planStatus.r18g && loginInfo.r18g_display_flag === 2 && loginInfo.age18 === 1)
                        ? (
                            <Alert severity='info'>
                                年齢区分・制限のあるプランが非表示になっています。すべてを表示するには表示設定を変更してください。<br />
                                <MuiButton onClick={() => setShowSetting(true)} variant='outlined'>設定</MuiButton>
                            </Alert>
                        ) : ""}
                        {false ? (<><div className='mb-5' style={{fontFamily:"Meiryo UI",fontSize:"24px",fontWeight:"bold"}}>支援中のプラン</div>
                        <Grid container spacing={2}>
                            <Plan data={[{"user_id":userInfo.user_id}]} />
                        </Grid></>): ""}
                        <div className='mb-5 mt-3' style={{fontFamily:"Meiryo UI",fontSize:"24px",fontWeight:"bold"}}>プラン一覧</div>
                        <Grid container spacing={2}>
                        {planList.map((d,i) => {
                            return <Plan key={i} data={d} />
                        })}
                        </Grid>
                    </Container>
                </Tab>
                ) : ""}
            </Tabs>
        </div>
        <Footer />
    </div>
    )
}

export default Character;
